import * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    ActionableContainer,
    Button,
    confirm,
    Description,
    Group,
    Heading,
    toast,
} from '@gitbook/spine-react';

import { apiClient, useSiteContext } from '../../../../../state';

export const UnpublishSite = React.memo(function UnpublishSite() {
    const { site } = useSiteContext();

    if (!site.published) {
        return null;
    }

    return (
        <ActionableContainer orientation="horizontal">
            <Group>
                <Heading>Unpublish site</Heading>
                <Description>
                    Your site will no longer be available to external audiences. You can republish
                    your site with the same URL at any time.
                </Description>
            </Group>
            <UnpublishSiteButton />
        </ActionableContainer>
    );
});

function UnpublishSiteButton() {
    const { site, organizationId } = useSiteContext();

    return (
        <Button
            kind="danger"
            size="medium"
            leadingIcon={Icon.Unpublish}
            label="Unpublish site"
            onPress={() => {
                void confirm({
                    title: 'Unpublish site?',
                    description:
                        'Your site will no longer be available to external audiences. You can republish your site with the same URL at any time.',
                    kind: 'danger',
                    confirmLabel: 'Unpublish',
                    onConfirm: async (_event, { preventClose }) => {
                        await toast.catch(
                            async () => {
                                await apiClient.sites.unpublishSite(organizationId, site.id);
                            },
                            'Error while unpublishing site',
                            { onReject: preventClose }
                        );
                    },
                });
            }}
        />
    );
}
